/* @flow */
// typecheck: ignore file
import React from 'react';

import Button from 'components/Button.jsx';
import HumanArray from 'components/HumanArray.jsx';
import Glyph from 'components/Glyph.jsx';
import Text from 'components/Text.jsx';

type Props = {
  avatar: React$Element<*>,
  participantNames: string[],
  closeNewChat: Function,
};

// There's a conflict between object-curly-spacing and flowtype/space-after-type-colon
// https://github.com/eslint/eslint/issues/6940
export default function ({participantNames, avatar, closeNewChat}: Props) {  // eslint-disable-line object-curly-spacing
  return (
    <div className="ChatListItem-content">
      <div className="ChatListItem-content-droplet">{avatar}</div>
      <div className="ChatListItem-content-body">
        <Text className="ChatListItem-name" truncate>
          <HumanArray sample={participantNames} total={participantNames.length} />
        </Text>
        <Text className="ChatListItem-snippet" truncate>{'Send your first message'}</Text>
        <hr className="ChatListItem-content-body-divider" />
      </div>
      <Button
        className="ChatListItem-closeButton"
        level="text"
        onClick={closeNewChat}
        eventElementName="ChatListItem-closeButton">
        <Glyph name="close" size="xsmall" solo />
      </Button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/chat/components/ChatListItemContentNew.jsx